import React from 'react'

import NavigationMenu from 'components_new/molecules/NavigationMenu'

import { ADMIN_NAV_MENU_ID } from 'components_new/organisms/Navbar/lib'

import { useNavigationActions } from 'redux/actions/NavigationMenu'
import { useNavigation } from 'redux/hooks/NavigationMenuStore'

import { getNavigationsItems } from './utils'
import { useTranslation } from 'language/translator'

const InternalNavigation = () => {
  const { t } = useTranslation()
  const { toggleNavigationItem } = useNavigationActions()
  const { open, expandedItems } = useNavigation()

  return (
    <NavigationMenu
      collapsed={{
        activePattern: '/data-platform*',
        href: '/data-platform/ontology/standard',
        iconName: 'EngineeringOutlined',
        value: !open
      }}
      expandedItems={expandedItems}
      id={ADMIN_NAV_MENU_ID}
      items={getNavigationsItems()}
      title={t('global', 'homepal_admin')}
      toggleNavigationItem={toggleNavigationItem}
    />
  )
}

export default InternalNavigation
